import e, { useState as r } from "react";
import { Popover as n } from "../../general/Popover/index.js";
import { componentName as t } from "../../../utils/bem/index.js";
import { K1Button as o } from "../K1Button/K1Button.js";
import { ITCAppLauncher as i } from "./ITCAppLauncher.js";
import { SsoPopup as a } from "../SsoPopup/SsoPopup.js";
function l(e, r) {
  (null == r || r > e.length) && (r = e.length);
  for (var n = 0, t = Array(r); n < r; n++) t[n] = e[n];
  return t;
}
function s(s) {
  var u,
    c,
    p,
    m = s.isK1SsoSession,
    f = s.isK1LoginEnabled,
    h = s.k1Link,
    d = s.hasAdminPermissions,
    y = s.ssoVersion,
    b = void 0 === y ? 1 : y,
    g = s.onK1LoginEnable,
    A = s.onK1ButtonClick,
    v = function (e) {
      if (Array.isArray(e)) return e;
    }(u = r(!1)) || function (e, r) {
      var n,
        t,
        o = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
      if (null != o) {
        var i = [],
          a = !0,
          l = !1;
        try {
          for (o = o.call(e); !(a = (n = o.next()).done) && (i.push(n.value), !r || i.length !== r); a = !0);
        } catch (e) {
          l = !0, t = e;
        } finally {
          try {
            a || null == o.return || o.return();
          } finally {
            if (l) throw t;
          }
        }
        return i;
      }
    }(u, 2) || function (e, r) {
      if (e) {
        if ("string" == typeof e) return l(e, r);
        var n = Object.prototype.toString.call(e).slice(8, -1);
        if ("Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n) return Array.from(n);
        if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return l(e, r);
      }
    }(u, 2) || function () {
      throw TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }(),
    E = v[0],
    L = v[1];
  return e.createElement("div", {
    className: t("itc-app-launcher-wrapper", ((p = "with-sso") in (c = {}) ? Object.defineProperty(c, p, {
      value: E,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : c[p] = E, c))
  }, m ? e.createElement(i, {
    cacheKey: "launcher-app-settings",
    k1Token: s.k1Token,
    useQaLauncherApi: s.useQaLauncherApi,
    apps: s.apps,
    launcherApiVersion: s.launcherApiVersion
  }) : e.createElement(e.Fragment, null, e.createElement(o, {
    className: E && "--with-sso",
    href: h,
    ssoVersion: b,
    onClick: function onClick(e) {
      2 === b && (e.preventDefault(), L(function (e) {
        return !e;
      })), null == A || A();
    }
  }), e.createElement(n, {
    onHide: function onHide() {
      return L(!1);
    },
    pointTo: "right",
    arrowPosition: "right",
    arrowSize: 0,
    edgeOffset: 0,
    spaceToTarget: 6,
    open: E
  }, e.createElement(a, {
    isK1LoginEnabled: f,
    hasAdminPermissions: d,
    onK1LoginEnable: g
  }))));
}
s.displayName = "ITCAppLauncherWrapper";
export { s as ITCLauncherWrapper };